import FitnessHeartRate from "./SVG/fitness-heart-rate.svg?react";

const FitnessHeart = () => {
  return <FitnessHeartRate />;
};

export default FitnessHeart;
